import React, { useMemo } from "react";
import Loader from "../../../components/Loader";
import {
  convertDateFormat,
  convertStringToArray,
  extractDateFromStr,
  getLatestUpdatedObject,
  sanitizeString,
} from "../../../Utils/utils";
import { useNavigate } from "react-router-dom";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import usePagination from "../../../hooks/usePagination";
import Pagination from "../../../components/Pagination/Pagination";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { imageUrl } from "../../../constants/constants";

const EventArchivePage = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const navigate = useNavigate();
  const {
    data: eventsData = [],
    error: eventsError,
    isLoading: eventsIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "archive_event",
    lang: languageType,
  });

  console.log(eventsData);

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(getLatestUpdatedObject(eventsData)?.changed);
  }, [eventsData]);

  const transformedData = useMemo(() => {
    return eventsData.map((item) => ({
      ...item,
      field_upload_image: convertStringToArray(item.field_upload_image),
    }));
  }, [eventsData]);

  const { currentItems, currentPage, totalPages, handlePageChange } =
    usePagination(transformedData, 12);

  if (eventsError) {
    return <div>Failed to load news. Please try again later.</div>;
  }

  if (eventsIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("Archived Events", "संग्रहीत गतिविधियाँ")}
        titleLink="/events-detail"
        levelTwo={false}
        levelThree={false}
        isActive={getText("Archived Events", "संग्रहीत गतिविधियाँ")}
      />

      <div className="inner-container">
        <div className="container">
          <section className="ourCompany events-sec innerevent">
            <div className="container">
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
              <div className="row mb-5">
                {currentItems.map((item, index) => (
                  <div
                    className="col-12 col-sm-12 col-md-3 col-lg-3"
                    key={index}
                  >
                    <div
                      className="card-sec"
                      key={index}
                      onClick={() => {
                        // navigate(`/events-detail/${item.nid}`);
                        navigate(`/archived-events/${item.nid}`);
                      }}
                    >
                      <div className="img-sec">
                        <img
                          src={
                            item?.field_upload_image?.[0]?.file_path
                              ? imageUrl + item.field_upload_image[0].file_path
                              : "images/dummy.png"
                          }
                          alt={item.title}
                        />
                      </div>
                      <div className="desc-sec">
                        {item.field_ordering_date && (
                          <span className="date">
                            {item.field_ordering_date}
                          </span>
                        )}
                        <p className="gallery-line-clamp">
                          {sanitizeString(item.title)}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </section>
        </div>
      </div>
    </>
  );
};

export default EventArchivePage;
